import React from "react";
import { passParamsThrough } from "../../../../validation/HForm";
import BaseTariffRow from "./BaseTariffRow";
import AnnuityTariffRow from "./AnnuityTariffRow";

const CouponHybridRowsTable = ({
  rows,
  isDiscountBonus,
  isDiscountBirthday,
  isPurity,
  isThings,
  isCars,
  checkValueInput,
  handleCopy,
  handleAddAfter,
  handleRemove,
  control,
  register,
  errors,
}) => {
  const props = { control, register, errors };

  return passParamsThrough(
    rows.map((number) => (
      <tbody key={number} className="hybrid-tariff-block">
        <tr className="tariff-header">
          <th scope="row" colSpan={1}></th>
          <th scope="row" colSpan={5}>
            <span className="font-size-larger">Базовый тариф</span>
          </th>
          <th colSpan={7}></th>
        </tr>
        <BaseTariffRow
          h="true"
          number={number}
          isDiscountBonus={isDiscountBonus}
          isDiscountBirthday={isDiscountBirthday}
          checkValueInput={checkValueInput}
          isPurity={isPurity}
          isThings={isThings}
          isCars={isCars}
          handleCopy={handleCopy}
          handleAddAfter={handleAddAfter}
          handleRemove={handleRemove}
          rows={rows}
        />
        <tr className="tariff-header">
          <th scope="row" colSpan={1}></th>
          <th scope="row" colSpan={5}>
            <span className="font-size-larger">Аннуитетный тариф</span>
            <br />
            <span>Срок, мес</span>
          </th>
          <th colSpan={7}></th>
        </tr>
        <AnnuityTariffRow
          h="true"
          number={number}
          isDiscountBonus={isDiscountBonus}
          isDiscountBirthday={isDiscountBirthday}
          checkValueInput={checkValueInput}
          isPurity={isPurity}
          isThings={isThings}
          isCars={isCars}
        />
      </tbody>
    )),
    props
  );
};

export default CouponHybridRowsTable;
